import 'react-app-polyfill/ie9';

import React from 'react';
import { CONST } from '../_config';

function NotFoundPage() {
    return (
      <>
        <div className="h-[calc(100vh-8rem)] flex items-center justify-center">
                        <section className="2xl:w-8/12 xl:w-10/12 mx-auto xl:px-0 px-6 w-full py-10   flex md:space-x-10  items-start  ">
                          <div className=" lg:w-4/6 w-full mx-auto space-y-10 md:px-10   text-center">
                            <div className="space-y-4 text-white/80 text-base font-normal ">
                              <div className="flex flex-col justify-center items-center md:space-y-10 space-y-6">
                                <div className="md:w-[12rem] w-[10rem] md:h-[12rem] h-[10rem] rounded-full bg-[#2196f3]/10 flex justify-center items-center">
                                  <div className="md:w-[10rem] w-[8rem] h-[8rem] md:h-[10rem] rounded-full bg-[#2196f3]/10 flex justify-center items-center">
                                  <img src={CONST.IMAGES_URL+'tp_icon_page_not_found.svg'} className='w-20'/>
                                  </div>
                                </div>
                                <h1 className="lg:text-5xl md:text-4xl text-3xl font-bold text-[#2196f3]">
                                  Page not Found!
                                </h1>
                              </div>

                              <h1 className="  py-2 font-normal md:text-3xl text-xl text-[#2196f3]  ">
                              Sorry we Couldn't find the Survey, please check URL. 
                              </h1>
                            </div>
 

                            <div className="fixed bottom-0  left-0 w-full">
                              <div className="xl:w-11/12 w-full mx-auto xl:px-0 px-4 md:py-6 py-4 md:bg-transparent bg-white/10">
                                <div className="w-full flex justify-end">
                                  <div className="flex flex-col md:justify-center items-center 2xl:space-y-10 xl:space-y-10   space-y-4   w-full  ">
                                    <div className="flex md:justify-end justify-center  w-full">
                                      <p className="text-sm text-slate-900/80 ">
                                        © Powered by
                                        <b className="ml-1 font-medium text-slate-900/100">
                                          HappyPlus
                                        </b>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/*  */}
                        </section>
                      </div>
      </>
    );
  }

export default NotFoundPage;